import { differenceInMinutes } from 'date-fns'
import i18next from 'i18next'

enum TimeUnit {
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS',
}

const translateTimeUnits = (unit: TimeUnit): string => {
  const language = i18next.language === 'de' ? Language.DE : Language.EN

  const unitMap: Record<TimeUnit, Record<Language, string>> = {
    [TimeUnit.SECONDS]: {
      [Language.DE]: 'Sek.',
      [Language.EN]: 'sec',
    },
    [TimeUnit.MINUTES]: {
      [Language.DE]: 'Min.',
      [Language.EN]: 'min',
    },
    [TimeUnit.HOURS]: {
      [Language.DE]: 'St.',
      [Language.EN]: 'h',
    },
    [TimeUnit.DAYS]: {
      [Language.DE]: 'T.',
      [Language.EN]: 'd',
    },
  }

  const translation = unitMap[unit][language]
  return translation
}

enum Language {
  EN = 'EN',
  DE = 'DE',
}

export const formatApproximateDifferenceInHoursAndMinutes = (
  start: Date,
  end: Date,
): string => {
  const diffInMinutes = Math.abs(differenceInMinutes(end, start))
  const diffInHours = Math.floor(diffInMinutes / 60)
  const diffInDays = Math.floor(diffInMinutes / (60 * 24))

  if (diffInMinutes < 1) {
    return `< 1 ${translateTimeUnits(TimeUnit.MINUTES)}`
  }

  if (diffInMinutes < 60) {
    return `${diffInMinutes} ${translateTimeUnits(TimeUnit.MINUTES)}`
  }

  if (diffInMinutes < 48 * 60) {
    return `ca. ${diffInHours} ${translateTimeUnits(TimeUnit.HOURS)}`
  }

  return `${diffInDays} ${translateTimeUnits(TimeUnit.DAYS)}`
}
